import React, { useEffect, useState } from "react"
import { useParams, Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import OEMRequestView from "./OEMRequestView"
import TraderOfferView from "./TraderOfferView"
import {
  GetTraderRequestByID,
  GetTraderRequestOffers,
} from "helpers/backend_helper"
import { useLoading } from "helpers/custom_hooks"
import { IsTraderCompany } from "helpers/misc_helpers"

const TraderRequestDetails = () => {
  const { id } = useParams()
  const setGlobalLoading = useLoading()
  const isTrader = IsTraderCompany()

  const [request, setRequest] = useState(null)
  const [offers, setOffers] = useState([])
  const [loading, setLoading] = useState(true)

  const loadData = async (silent = false) => {
    // Bei silent=true (Refresh nach Aktion) kein globaler Ladeindikator,
    // damit der Inhalt sichtbar bleibt
    if (!silent) {
      setLoading(true)
      setGlobalLoading(true)
    }
    try {
      const [req, offs] = await Promise.all([
        GetTraderRequestByID(id),
        GetTraderRequestOffers(id),
      ])
      setRequest(req)
      setOffers(offs || [])
    } catch (error) {
      console.error("Error loading trader request:", error)
    }
    if (!silent) {
      setLoading(false)
      setGlobalLoading(false)
    }
  }

  useEffect(() => {
    loadData(false)
  }, [id])

  // Nur beim allerersten Laden (noch kein request-Objekt) Null zurückgeben
  if (loading && !request) return null

  // Trader: eigenes Angebot ist das einzige Element in offers[]
  const myOffer = isTrader ? (offers[0] || null) : null

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs
          title="Excess Price Check"
          breadcrumbItem={request.title}
        />
        <Row>
          <Col xs={12} className="mb-2">
            <Link to="/trader-requests" className="text-muted">
              <i className="bx bx-arrow-back me-1"></i>
              Back to Excess Price Check
            </Link>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {isTrader ? (
              <TraderOfferView
                request={request}
                myOffer={myOffer}
                onRefresh={() => loadData(true)}
              />
            ) : (
              <OEMRequestView
                request={request}
                offers={offers}
                onRefresh={() => loadData(true)}
              />
            )}
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default TraderRequestDetails
